import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Cell
} from 'recharts';
import { formatPercent } from 'utils';
import { colors } from '../Utils';
import { tooltipStylePadded } from '../Tooltips/utils';

const dummyData = [
  { name: 'In a very good year', value: 35 },
  { name: 'In a good year', value: 20 },
  { name: 'On average', value: 25 },
  { name: 'In a bad Year', value: 5 },
  { name: 'In a very Bad Year', value: -10 }
];

interface ForecastGrossInvReturnsProps {
  data: Array<{ name: string; value: number }>;
}
const ForecastGrossInvReturns = ({ data }: ForecastGrossInvReturnsProps) => {
  const isDataProvided = data && data.length > 0;
  const dataToRender = isDataProvided ? data : dummyData;
  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart
        data={dataToRender}
        margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis dataKey="name" axisLine={false} tickLine={false} />
        <YAxis unit="%" axisLine={false} tickLine={false} />
        <Tooltip
          formatter={(val: string) => formatPercent(val)}
          contentStyle={tooltipStylePadded}
        />

        <Bar dataKey="value" maxBarSize={90}>
          <LabelList
            dataKey="value"
            position="top"
            formatter={(val: string) => formatPercent(val)}
          />
          {dataToRender.map((_entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors(index, isDataProvided, 'secondary')}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ForecastGrossInvReturns;
